// @flow

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {map, contains, filter} from 'ramda'
import {portfoliosSelectors, appSelectors, formActions} from '@/store'
import type {Language} from '@/types'
import {isSharedPortfolio} from '@/views/util'
import FaShare from 'react-icons/lib/fa/share-alt'

import './portfolio-multi-select.css'

type Props = {
  activePortfolioId: number,
  portfolios: Array<Object>,
  includeAll: ?boolean,
  setFormData: (?Object) => void,
  l: Language,
}

const isAll = (val) => val === 'All'

const isChecked = (id, idList) => contains(id, idList)

const isNotActiveId = (activeId, id) => id !== activeId

const isSharedPortfoliosWithAddPermission = (portfolio) => isSharedPortfolio(portfolio) &&
  portfolio.permissions.includes('Add')

const getDisplayedPortfolios = (activeId, portfolios) =>
  filter((portfolio) => {
    return (portfolio.sharedByUserName ? isSharedPortfoliosWithAddPermission(portfolio) : !portfolio.sharedByUserName) &&
      isNotActiveId(activeId, portfolio.portfolioId) && portfolio.portfolioId !== 0
  }, portfolios)

const checkIfAllNeedsToBeChecked = (state) =>
  state.shownPortfolios.length === state.selectedPortfolioIds.length + 1

export class RawPortfolioSelect extends Component<Props, *> {
  constructor (props: Props) {
    super(props)
    this.state = {
      selectedPortfolioIds: [],
      isAll: false,
      shownPortfolios: getDisplayedPortfolios(props.activePortfolioId, props.portfolios),
    }
  }

  validateList = () => {
    this.state.selectedPortfolioIds.length > 0
      ? this.props.setFormData({'selectedPortfolioIds': this.state.selectedPortfolioIds})
      : this.props.setFormData(null)
  }

  updateAll = (checked: boolean) => {
    if (checked) {
      this.setState((prevState) => {
        return {
          selectedPortfolioIds: map((portfolio) => portfolio.portfolioId,
            prevState.shownPortfolios),
          isAll: true,
        }
      }, this.validateList)
    } else {
      this.setState((prevState) => {
        return {
          selectedPortfolioIds: [],
          isAll: false,
        }
      }, this.validateList)
    }
  }

  updateOne = (checked: boolean, value: any) => {
    value = Number(value)
    if (checked) {
      this.setState((prevState) => {
        const newState = {}
        newState['selectedPortfolioIds'] = [...prevState.selectedPortfolioIds, value]
        if (this.props.includeAll && checkIfAllNeedsToBeChecked(prevState)) {
          newState['isAll'] = true
        }
        return newState
      }, this.validateList)
    } else {
      this.setState((prevState) => {
        let selectedList = [...prevState.selectedPortfolioIds]
        const index = selectedList.indexOf(value)
        selectedList.splice(index, 1)
        const newState = {}
        newState['selectedPortfolioIds'] = selectedList
        if (this.props.includeAll && prevState.isAll) {
          newState['isAll'] = false
        }
        return newState
      }, this.validateList)
    }
  }

  update = (e: any) => {
    const {checked, value} = e.currentTarget
    this.props.includeAll && isAll(value) ? this.updateAll(checked)
      : this.updateOne(checked, value)
  }

  renderPortfolio = (portfolio: Object) => {
    const checked = isChecked(portfolio.portfolioId, this.state.selectedPortfolioIds)
    return (
      portfolio.portfolioId !== 0 &&
      <li key={portfolio.portfolioId} className={checked ? 'active' : ''}>
        <label>
          <input type='checkbox'
            checked={checked}
            value={portfolio.portfolioId}
            onChange={this.update}
          />
          <span>{portfolio.name}</span>
          {isSharedPortfolio(portfolio) ? <span className='share-icon'><FaShare /></span> : null}
        </label>
      </li>
    )
  }

  render = () => {
    const {
      includeAll,
      l,
    } = this.props

    const checkedAll = this.state.isAll
    const hasShownPortfolios = this.state.shownPortfolios.length > 0
    return (
      <ul className="portfolio-multi-select">
        {includeAll && hasShownPortfolios
          ? <li className={checkedAll ? 'active' : ''}>
            <label>
              <input type='checkbox'
                checked={checkedAll}
                value='All'
                onChange={this.update}
              />
              <span>{l('All Portfolios')}</span>
            </label>
          </li>
          : null}
        {hasShownPortfolios ? map(this.renderPortfolio, this.state.shownPortfolios)
          : <li>{l('No portfolios')}</li>}
      </ul>
    )
  }
}

const mapStateToProps = (state) => ({
  activePortfolioId: appSelectors.getActivePortfolioId(state),
  portfolios: portfoliosSelectors.getPortfolios(state),
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  formActions,
)(RawPortfolioSelect)



// WEBPACK FOOTER //
// ./src/views/forms/portfolio-multi-select.js